import { useRef, useEffect } from 'react';

import { getPadValue } from './helper';
import { Wrap, Col, ColLabel, ScrollList, Opt } from './columns.styled';

const range = (n) => Array.from({ length: n }, (_, i) => i);

const Column = ({ label, count, value, onChange }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const el = ref.current.querySelector('[data-active="1"]');
      if (el) {
        el.scrollIntoView({ block: 'center' });
      }
    }
  }, [value]);

  return (
    <Col>
      <ColLabel>{label}</ColLabel>
      <ScrollList ref={ref}>
        {range(count).map((n) => (
          <Opt key={n} data-active={n === value ? '1' : '0'} className={n === value ? 'active' : ''} onClick={() => onChange(n)}>
            {getPadValue(n)}
          </Opt>
        ))}
      </ScrollList>
    </Col>
  );
};

export const Columns = ({ hour, minute, sec, setHour, setMinute, setSecund }) => {
  return (
    <Wrap>
      <Column label="Часы" count={24} value={hour} onChange={setHour} />
      <Column label="Мин" count={60} value={minute} onChange={setMinute} />
      <Column label="Сек" count={60} value={sec} onChange={setSecund} />
    </Wrap>
  );
};
